module.exports = __webpack_public_path__ + "static/media/arrow_drop_down.b98c6ce6.svg";